export const MARGIN = {
  left: 45,
  right: 100,
};
